import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { DataTableHeader } from '../../../components/DataTable/types';
import {
  LEADING_COLUMN_WIDTH,
  CELL_HORIZONTAL_PADDING,
} from '../../../components/DataTable/DataTable';

const CARD_HORIZONTAL_PADDING = '40px';

interface TransactionsHeaderProps {
  headers: DataTableHeader[];
  totals: Record<string, ReactNode>;
  hasLeadingColumn?: boolean;
  hasTrailingSpacer?: boolean;
}

const TransactionsHeaderLayout: React.FC<TransactionsHeaderProps> = ({
  headers,
  totals,
  hasLeadingColumn = false,
  hasTrailingSpacer = false,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        alignItems: 'flex-end',
        paddingLeft: CARD_HORIZONTAL_PADDING,
        paddingRight: CARD_HORIZONTAL_PADDING,
      }}>
      {hasLeadingColumn && (
        <Box
          sx={{
            width: LEADING_COLUMN_WIDTH,
            maxWidth: LEADING_COLUMN_WIDTH,
            minWidth: LEADING_COLUMN_WIDTH,
            flex: 'none',
          }}
        />
      )}
      {headers.map((header, index) => {
        const isLastHeader = index === headers.length - 1;
        return (
          <Box
            key={header.label}
            sx={{
              flex: header.flex,
              textAlign: header.align || 'left',
              display: 'flex',
              justifyContent: header.align === 'right' ? 'flex-end' : 'flex-start',
              alignItems: 'center',
              minWidth: 0,
              overflow: 'visible',
              ...(header.align === 'right' &&
                !isLastHeader && {
                  paddingRight: CELL_HORIZONTAL_PADDING,
                }),
            }}>
            {totals[header.label] || null}
          </Box>
        );
      })}
      {hasTrailingSpacer && (
        <Box
          sx={{
            width: LEADING_COLUMN_WIDTH,
            maxWidth: LEADING_COLUMN_WIDTH,
            minWidth: LEADING_COLUMN_WIDTH,
            flex: 'none',
          }}
        />
      )}
    </Box>
  );
};

export default TransactionsHeaderLayout;
